/**
 * Created by Pankaj on 24-Apr-2020
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {TimelineLite, TweenLite} from "gsap";
import {ISymbolPositions} from "../winpresentation/geniefeature/GenieFeatureController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WalkingWildView} from "./WalkingWildView";
import {RomanEmpireGameModuleConfig} from "../RomanEmpireGameModuleConfig";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import Timeline = gsap.Timeline;

export class WildMultiplierContainer extends PIXI.Container {

    private _sprite: TimelineSprite;
    private _goldenGenie: TimelineSprite;
    private _reelId: number;
    private _nextReelId: number;
    private readonly _symbolId: number;
    private readonly _text: PIXI.BitmapText;
    private readonly SCATTER: string = "movingScatter";
    private _multiplierValue: number;
    private _nextMultiplierValue: number;
    private _isGoldenGenie: boolean = false;
    private _isHandOver: boolean = false;
    private _isOut: boolean = false;

    //private _revealMask: PIXI.Graphics;


    constructor(reelId: number, symbolId: number, initialMultiplierValue: number, isHandOver: boolean = false) {
        super();
        this._reelId = reelId;
        this._symbolId = symbolId;
        this._isHandOver = isHandOver;
        this._sprite = this.createSprite();
        this._goldenGenie = this.createSprite("goldenGenie");
        this._text = this.createMultiplierText();
        this.position.set(Helper.getSymbolPositions(reelId, symbolId)[0] - GameConfig.instance.REEL_AREA_POS_X, Helper.getSymbolPositions(reelId, symbolId)[1]);
        this.addChild(this._sprite, this._goldenGenie);
        this.addChild(this._text);
        this.multiplierValue = initialMultiplierValue;
        //this.isGoldenGenie = isDefaultGoldenGenie;
        this._goldenGenie.mask = this.createRevealMask();
    }

    private createRevealMask(): PIXI.Graphics | PIXI.Sprite {
        //const revealMask = new PIXI.Graphics();
        const revealMask = new PIXI.Sprite(GameResources.getTextures("mask")[0]);
        revealMask.anchor.set(0.5);
        revealMask.scale.set(2.5, 2);
        // revealMask.beginFill(0xffffff, 0.000000001);
        // revealMask.drawRect(0, 0, this._goldenGenie.width, this._goldenGenie.height);
        // revealMask.endFill();
        this.addChild(revealMask);
        //revealMask.pivot.set(revealMask.width * 0.5, revealMask.height * 0.5);
        return revealMask;
    }

    public transformToGoldenGenie() {
        this._isGoldenGenie = true;
        // const revealMask = this.createRevealMask();
        // this._goldenGenie.mask = revealMask;
        this._goldenGenie.playLoop();
        this._goldenGenie.show();

        return TweenLite.fromTo(this._goldenGenie.mask, 0.8, {y: this._goldenGenie.height}, {
            y: 0, onComplete: () => {
                // (this._goldenGenie.mask as any) = null;
                // this.removeChild(revealMask);
                this.sprite.stopLoop();
                this.sprite.hide();
            }
        });
    }

    public transformToNormal() {
        this.sprite.playLoop();
        this.sprite.show();
        this._goldenGenie.stopLoop();
        this._goldenGenie.hide();
    }

    public playOutAnimation(isGolden: boolean): TweenLite {
        this._isOut = true;
        if (isGolden) {
            //this._goldenGenie.mask = this._sprite;
            (this._goldenGenie.mask as PIXI.Graphics).width = RomanEmpireGameConfig.instance.SYMBOL_WIDTH + 20;
            this._sprite.hide();
        } else {
            this._sprite.mask = this._goldenGenie;
            this._goldenGenie.show();
        }
        return TweenLite.to(isGolden ? this._goldenGenie : this._sprite, WalkingWildView.WALKING_DURATION * 0.5, {
            x: -this._sprite.width, onComplete: () => {
                this.sprite.stopLoop();
                this.sprite.hide();
                this._goldenGenie.stopLoop();
                this._goldenGenie.hide();
            }
        });
    }

    public playGoldenBlurAnim(): TweenLite {
        const goldenBlur: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("goldenFrameBlur")[0]);
        this.addChildAt(goldenBlur, 0);
        goldenBlur.blendMode = PIXI.BLEND_MODES.ADD;
        goldenBlur.anchor.set(0.5);
        goldenBlur.scale.x = 0.7;

        return TweenLite.to(goldenBlur.scale, 0.3, {
            x: 1, onStart: () => {
                RomanEmpireGameModuleConfig.foregroundAnimation.showReelFrameGlow();
            }, onComplete: () => {
                TweenLite.to(goldenBlur.scale, 0.3, {
                    x: 0.7, onComplete: () => {
                        RomanEmpireGameModuleConfig.foregroundAnimation.hideReelFrameGlow();
                        this.removeChild(goldenBlur);
                    }
                });
            }
        });
    }

    public playPuffsAnim(isGolden: boolean = false, isReverse: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const puffsAnim: TimelineSprite = this.createSprite("puffs", undefined, 27);
        const puffsAnimCopy: TimelineSprite = this.createSprite("puffs", undefined, 27);
        puffsAnim.tint = isGolden ? 0xFAA501 : 0x1BEEFA;
        puffsAnimCopy.tint = isGolden ? 0xFAA501 : 0x1BEEFA;
        puffsAnimCopy.alpha = 0.7;
        this.addChild(puffsAnim, puffsAnimCopy);
        puffsAnim.y -= 30;
        puffsAnimCopy.y -= 30;
        puffsAnim.blendMode = PIXI.BLEND_MODES.ADD;
        puffsAnimCopy.blendMode = PIXI.BLEND_MODES.ADD;
        isReverse && (puffsAnim.scale.y = -1);
        isReverse && (puffsAnimCopy.scale.y = -1);
        //isGolden
        tl.add([puffsAnimCopy.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
            this.removeChild(puffsAnim);
        }), puffsAnim.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
            this.removeChild(puffsAnim);
        })]);
        return tl;
    }

    public playParticlesAnim(): Timeline {
        const spriteTl: TimelineSprite = this.createSprite("commonParticles3", undefined, 27);
        this.addChild(spriteTl);
        return spriteTl.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
            this.removeChild(spriteTl);
        });
    }

    public playBlastAnim(isGolden: boolean = false): Timeline {
        const blast: TimelineSprite = this.createSprite("goldenBlast", isGolden ? [0, 60] : [0, 0], 27, true);
        this.addChildAt(blast, this.children.indexOf(this._text));
        //blast.blendMode = PIXI.BLEND_MODES.ADD;
        return blast.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
            this.removeChild(blast);
        });
    }

    public playMultiplierHandOverAnim(pos: PIXI.Point): TweenLite {
        return TweenLite.to(this._text, 0.2, {x: this._text.x + pos.x, y: this._text.y + pos.y});
    }


    /**
     * Multiplier value from sprite
     */
    public createMultiplierText(): PIXI.BitmapText {
        let multiplierText: PIXI.BitmapText = this.createBitmapText("x" + this.multiplierValue, [0, 60], "center");
        multiplierText.anchor = 0.5;
        multiplierText.pivot.y = multiplierText.height * 0.3;
        return multiplierText;

    }

    public multiplierScaleOut(time?: number, scale?: number): TweenLite {
        return TweenLite.to(this._text.scale, time || WalkingWildView.WALKING_DURATION * 0.5, {
            x: scale != undefined ? scale : 0.6,
            y: scale != undefined ? scale : 0.6
        });
    }

    public playMultiplierTransformAnim(isPuffs: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this.multiplierValue = this.nextMultiplierValue;
        });
        isPuffs && tl.add(this.playRaysAnim());
        tl.add(TweenLite.to(this._text.scale, WalkingWildView.WALKING_DURATION * 0.2, {x: 1.5, y: 1.5}), 0.1);
        tl.add(TweenLite.to(this._text.scale, WalkingWildView.WALKING_DURATION * 0.2, {x: 1, y: 1}));
        return tl;
    }


    private playRaysAnim(): Timeline {
        const genieFeatureRays: TimelineSprite = this.createSprite("sparklesWinAnimation", [5, 55], 30);
        genieFeatureRays.blendMode = PIXI.BLEND_MODES.ADD;
        genieFeatureRays.scale.set(0.5);
        this.addChild(genieFeatureRays);
        return genieFeatureRays.getAnimationAutoShowHide(true, true);
        // return TweenLite.to(genieFeatureRays.scale, 0.3, {x: 1, y: 1, onComplete:()=>{
        //     this.removeChild(genieFeatureRays);
        //     }})
    }

    /**
     * To create Text from Bitmap font images
     * */
    public createBitmapText(text: string, position?: ISymbolPositions | number[], align?: string): PIXI.BitmapText {
        const bitmapText: PIXI.BitmapText = new PIXI.BitmapText(text, {
            fontName: "NumbersWinCountUp",
            fontSize: 22,
            align: align || "center",
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        if (position) {
            position = position instanceof Array ? position : Helper.getSymbolPositions(position.reelId, position.symbolId);
            bitmapText.position.set(position[0], position[1]);
        }
        return bitmapText;
    }

    /**
     * To create wild multiplier sprite
     */
    public createSprite(texture?: string, pos?: number[], sourceFPS?: number, isJPEG: boolean = false): TimelineSprite {
        const textures: PIXI.Texture [] = GameResources.getTextures(texture || this.SCATTER);
        const sprite: TimelineSprite = new TimelineSprite(textures, sourceFPS);
        if (pos) {
            sprite.position.set(pos[0], pos[1]);
        }
        sprite.hide();
        sprite.anchor.set(0.5, 0.5);
        isJPEG && (sprite.blendMode = PIXI.BLEND_MODES.ADD);
        return sprite;
    }

    get multiplierValue(): number {
        return this._multiplierValue;
    }

    set multiplierValue(value: number) {
        this._multiplierValue = value;
        this._text.text = "x" + value;
    }

    get reelId(): number {
        return this._reelId;
    }

    set reelId(value: number) {
        this._reelId = value;
    }

    get symbolId(): number {
        return this._symbolId;
    }

    get sprite(): TimelineSprite {
        return this._sprite;
    }

    get nextMultiplierValue(): number {
        return this._nextMultiplierValue;
    }

    set nextMultiplierValue(value: number) {
        this._nextMultiplierValue = value;
    }

    get isGoldenGenie(): boolean {
        return this._isGoldenGenie;
    }

    set isGoldenGenie(value: boolean) {
        //value ? this.transformToGoldenGenie() : this.transformToNormal();
        if (value) {
            this.sprite.stopLoop();
            this.sprite.hide();
            this._goldenGenie.playLoop();
            this._goldenGenie.show();
        } else {
            this._goldenGenie.stopLoop();
            this._goldenGenie.hide();
            this.sprite.playLoop();
            this.sprite.show();
        }
        this._isGoldenGenie = value;
    }

    get text(): PIXI.BitmapText {
        return this._text;
    }

    get isOut(): boolean {
        return this._isOut;
    }

    get nextReelId(): number {
        return this._nextReelId;
    }

    set nextReelId(value: number) {
        this._nextReelId = value;
    }

    set isHandOver(value: boolean) {
        this._isHandOver = value;
    }

    get isHandOver(): boolean {
        return this._isHandOver;
    }
}
